<template>
  <div >
    <el-form :model="ruleForm" class="formpanel" status-icon :rules="rules" ref="ruleForm" label-width="60px">
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="ruleForm.phone" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="smscode">
        <el-input placeholder="请输入内容" v-model="ruleForm.smscode">
          <el-button slot="append" :disabled="yzmabled" @click="getcode">{{ruleForm.btntxt}}</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <div style="display: flex;flex-flow: row;justify-content: flex-end; margin-top: 30px;">
      <el-button class="formpanelbtn" type="primary" icon="el-icon-edit" @click="submitForm('ruleForm')">立即验证</el-button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'ValidPhone',
    data() {
      var checkSMSCode = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入验证码'));
        } else {
          if (this.ruleForm.sms === value) {
            callback()
          } else {
            callback(new Error('请输入正确的验证码'))
          }
          const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
          console.log(reg.test(value))
          if (reg.test(value)) {
          } else {
            return callback(new Error('请输入正确的手机号'))
          }
        }
      };
      var checkPhone = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入手机号码'));
        } else {
          const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
          console.log(reg.test(value))
          if (reg.test(value)) {
            var qstr = 'username = ' + value
            that.$http({
              url: 'https://api.sqnetsoft.cn/account/getaccountlist',
              method: 'post',
              data: {
                whereinfo: {String: qstr, Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  window.console.log(res)
                  var tmpdata = JSON.parse(res.data.data)
                  if (tmpdata.id.Int64 === 0) {
                    window.console.log('获取用户失败')
                    return callback(new Error('该账号不存在'))
                  } else {
                    localStorage.setItem('accountid',tmpdata.id.Int64)
                    callback()
                  }
                  // 把相关数据缓存到本地
                } else {
                  window.console.log('获取用户失败')
                }
              })
              .catch(function (error) {
                window.console.log(error)
              })
          } else {
            return callback(new Error('请输入正确的手机号'))
          }
        }
      };
      return {
        yzmabled: false,
        ruleForm: {
          phone: '',
          smscode: '',
          ifsend: '0',
          sms:'',
          btntxt: '获取验证码',
          sytime: 60
        },
        rules: {
          phone: [
            { validator: checkPhone, trigger: 'blur' }
          ],
          smscode: [
            { validator: checkSMSCode, trigger: 'blur' }
          ]
        }
      };
    },
    mounted: function () {
      that = this
      /* 获取是否通过手机验证 */
    },
    methods: {
      getcode () {
        if (this.ruleForm.phone !== '') {
          this.yzmabled = true;
          let interval = window.setInterval(function() {
            that.ruleForm.btntxt = that.ruleForm.sytime + '秒后重发';
            --that.ruleForm.sytime;
            if (that.ruleForm.sytime < 0) {
              that.ruleForm.btntxt = '获取验证码';
              that.ruleForm.sytime = 60;
              that.yzmabled = false;
              window.clearInterval(interval);
            }
          }, 1000);
          var datatmp = {
            vphone: this.ruleForm.phone,
            issend: parseInt(this.ruleForm.ifsend)
          }
          that.$http({
            url: 'https://api.sqnetsoft.cn/account/getsms',
            method: 'post',
            data: datatmp,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.success) {
                // 把相关数据缓存到本地
                window.console.log(res)
                if (parseInt(that.ruleForm.ifsend) === 0) {
                  that.ruleForm.smscode = res.data.data
                }
                that.ruleForm.sms = res.data.data
              }
            })
            .catch(function (error) {
              window.console.log(error)
            })
        } else {
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid && this.ruleForm.sms === this.ruleForm.smscode) {
            localStorage.setItem('username',this.ruleForm.phone)
            localStorage.setItem('repassstep',2)
            that.$emit('regtwo');
          } else {
            return false;
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/regedit/ValidPhone.vue